const LOGIN_PREVIEW_LINK = 'https://login.preview.xing.com';
const PREVIEW_HOSTNAME = 'preview.xing.com';
const LOGIN_PRODUCTION_LINK = 'https://login.xing.com';
const XINGBOX_IDENTIFIER = '.kenv.xing.com';
const getXingboxName = (hostname) => {
    const partsBeforeXingboxIdentifier = hostname
        .split(XINGBOX_IDENTIFIER)[0]
        .split('.');
    const lastItemIndex = partsBeforeXingboxIdentifier.length - 1;
    return partsBeforeXingboxIdentifier[lastItemIndex];
};
export const getLoginLink = () => {
    var _a;
    const hostname = ((_a = global === null || global === void 0 ? void 0 : global.location) === null || _a === void 0 ? void 0 : _a.hostname) || '';
    if (hostname.includes('localhost') || hostname.includes(PREVIEW_HOSTNAME))
        return LOGIN_PREVIEW_LINK;
    if (hostname.includes(XINGBOX_IDENTIFIER)) {
        const xingboxName = getXingboxName(hostname);
        return `http://login.${xingboxName}.kenv.xing.com`;
    }
    return LOGIN_PRODUCTION_LINK;
};
//# sourceMappingURL=get-login-link.js.map